import * as React from 'react';
import { default as Slider } from 'react-slick';
import { IImageData } from 'models/common';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

require('./style.css');

interface IProps {
	coverImages: any;
}

class ArticleCoverSlider extends React.Component<IProps, {}> {
	private isTimerActive: boolean = true;

	public render() {
		const { coverImages } = this.props;

		const settings: any = {
			dots: true,
			infinite: true,
			speed: 710,
			autoplaySpeed: 5400,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dotsClass: 'articleCardSliderDots',
			swipe: false,
			pauseOnHover: false,
			easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
			afterChange: () => {
				if (!this.isTimerActive) {
					this.isTimerActive = true;
					this.forceUpdate();
				}
			},
			beforeChange: () => {
				if (this.isTimerActive) {
					this.isTimerActive = false;
					this.forceUpdate();
				}
			},
		};

		const coverSliders = [];
		coverImages.map((item: IImageData, index) => {
			coverSliders.push(
				<div key={'cover_slide' + index} className="singleSlide">
					<div className="backgroundDesktop" style={{ backgroundImage: `url(${item.href})` }} />
					<div className="backgroundMobile" style={{ backgroundImage: `url(${item.href})` }} />
					<div className="singleSlideContainer">
						<div className="textHolder">
							<div className="author">
								<span className="text">{item.author}</span>
							</div>
							<div className="title">
								<span className="topRow">{item.description}</span>
							</div>
						</div>
					</div>
				</div>,
			);
		});

		return (
			<div className="articleCardCoverSlider">
				<div className="articleCardSliderContainer">
					<div className="sliderHolder">
						<div className="sliderHolder">
							<div className="sliderTopText">
								<div className="topTextHolder">
									<div className={`timer ${this.isTimerActive ? 'active' : ''}`} style={{ display: 'display-block' }} />
									<div className="clear" />
								</div>
							</div>
						</div>
						<Slider {...settings}>{coverSliders}</Slider>
					</div>
				</div>
			</div>
		);
	}
}

export { ArticleCoverSlider };
